import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/customer-info/types-of-customers/client.jsx");
